import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../../axios";
import { Helmet } from "react-helmet";
import moment from "moment";

import styles from "./View.module.css";

import Spinner from "../../../components/Spinner/Spinner";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import Button from "../../../components/Button/Button";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AddNewIcon from "../../../assets/images/add-new-icon.svg";

import Banks from "../Banks/Index";
import Brokers from "../Brokers/Index";
import Tickets from "../Tickets/Tickets";
import Ledgers from "../Ledgers/Index";
import Products from "../Products/Index";
import Transactions from "../Transactions/Index";
import Comments from "../Comments/Index";
class View extends Component {
  state = {
    user: null,
    brokers: null,
    activeTab: "overview",
    isLoading: false,
  };

  componentDidMount() {
    this.fetchUserDetails();
  }

  fetchUserDetails = () => {
    const { id } = this.props.match.params;

    axios
      .get(`/users/${id}`)
      .then((response) => {
        this.setState({ user: response.data });
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  fetchBrokers = () => {
    const { id } = this.props.match.params;
    axios
      .get(`/users/${id}/broker-accounts?page=1&per-page=999`)
      .then((response) => {
        this.setState({ brokers: response.data });
      })
      .catch((error) => {
        if (error.response.data.code === 2001) {
          const errors = error.response.data.errors;
          toast.error(Object.values(errors[0])[0]);
        } else {
          toast.error(error.response.data.message);
        }
      });
  };

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
    if (
      this.state.activeTab !== "overview" ||
      this.state.activeTab !== "comments"
    ) {
      this.fetchBrokers();
    }
  };

  render() {
    const { user, brokers } = this.state;

    return (
      <div className={styles.View}>
        <Helmet>
          <title>View Details | User | Lara Capital</title>
        </Helmet>
        <div className="PageHeader">
          <div className="ContentLeft">
            <div className="Title">
              <h1>Users</h1>
            </div>
            <Breadcrumb>
              <li>
                <Link to="/">Dashboard</Link>
              </li>
              <li>
                <Link to="/users">Users</Link>
              </li>
              <li>View</li>
            </Breadcrumb>
          </div>
          <div className="ContentRight">
            <Button btnType="Success" elementType="link" link="/users/create">
              <img src={AddNewIcon} alt="New User" /> <span>New</span>
            </Button>
          </div>
        </div>
        {user ? (
          <>
            <div className={[styles.PageNavigation, "PageContent"].join(" ")}>
              <div className={styles.NavigationMenu}>
                <ul>
                  <li
                    className={
                      this.state.activeTab === "overview" ? styles.Active : null
                    }
                    onClick={() => this.setActiveTab("overview")}
                  >
                    Profile
                  </li>
                  <li
                    className={
                      this.state.activeTab === "ledger" ? styles.Active : null
                    }
                    onClick={() => this.setActiveTab("ledger")}
                  >
                    Ledger
                  </li>
                  <li
                    className={
                      this.state.activeTab === "products" ? styles.Active : null
                    }
                    onClick={() => this.setActiveTab("products")}
                  >
                    Products
                  </li>
                  <li
                    className={
                      this.state.activeTab === "transactions"
                        ? styles.Active
                        : null
                    }
                    onClick={() => this.setActiveTab("transactions")}
                  >
                    Transactions
                  </li>
                  <li
                    className={
                      this.state.activeTab === "comments" ? styles.Active : null
                    }
                    onClick={() => this.setActiveTab("comments")}
                  >
                    Comments
                  </li>
                </ul>
              </div>
            </div>
            {this.state.activeTab === "overview" ? (
              <>
                <div className={["PageContent", styles.UserOverview].join(" ")}>
                  <div className={styles.DetailsContainer}>
                    <div className="ContentHeader">
                      <h2>User Details</h2>
                    </div>
                    <div className={styles.DetailOverview}>
                      <div className={styles.Detail}>
                        <div>Name</div>
                        <div>
                          {user.title +
                            ". " +
                            user.first_name +
                            " " +
                            user.last_name}
                        </div>
                      </div>
                      <div className={styles.Detail}>
                        <div>User ID</div>
                        <div>{user.user_id}</div>
                      </div>
                      <div className={styles.Detail}>
                        <div>Email</div>
                        <div>{user.email}</div>
                      </div>
                      <div className={styles.Detail}>
                        <div>Phone</div>
                        <div>{user.phone}</div>
                      </div>
                      <div className={styles.Detail}>
                        <div>PAN</div>
                        <div>{user.pan}</div>
                      </div>
                      <div className={styles.Detail}>
                        <div>Date of Birth</div>
                        <div>
                          {moment(user.date_of_birth).format("DD MMM YYYY")}
                        </div>
                      </div>
                      <div className={styles.Detail}>
                        <div>Address</div>
                        <div>{user.address}</div>
                      </div>
                      <div className={styles.Detail}>
                        <div>Status</div>
                        <div>{user.status.name}</div>
                      </div>
                      <div className={styles.Detail}>
                        <div>Registered On</div>
                        <div>
                          {moment(user.created_at).format(
                            "DD MMM YYYY, h:mm A"
                          )}
                        </div>
                      </div>
                      <div className={styles.Detail}>
                        <div>Last Updated On</div>
                        <div>
                          {user.updated_at
                            ? moment(user.updated_at).format(
                                "DD MMM YYYY, h:mm A"
                              )
                            : "NA"}
                        </div>
                      </div>
                      <div className={styles.Detail}>
                        <div>Last Login</div>
                        <div>
                          {user.last_login
                            ? moment(user.last_login).format(
                                "DD MMM YYYY, h:mm A"
                              )
                            : "NA"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={["PageContent", styles.ProfitLoss].join(" ")}>
                  <div className="ContentHeader">
                    <h2>Demat Accounts</h2>
                  </div>
                  <Brokers userId={user.id} />
                </div>

                <div className={["PageContent", styles.ProfitLoss].join(" ")}>
                  <div className="ContentHeader">
                    <h2>Banks</h2>
                  </div>
                  <Banks userId={user.id} />
                </div>

                <div className={["PageContent", styles.Tickets].join(" ")}>
                  <div className="ContentHeader">
                    <h2>Tickets</h2>
                  </div>
                  <Tickets userId={user.id} />
                </div>
              </>
            ) : null}

            {brokers && this.state.activeTab === "ledger" ? (
              <div className={["PageContent", styles.Ledgers].join(" ")}>
                {brokers.map((item) => {
                  return <Ledgers userId={user.id} broker={item.broker} />;
                })}
              </div>
            ) : null}

            {brokers && this.state.activeTab === "products" ? (
              <div className={["PageContent", styles.Products].join(" ")}>
                {brokers.map((item) => {
                  return <Products userId={user.id} broker={item.broker} />;
                })}
              </div>
            ) : null}

            {brokers && this.state.activeTab === "transactions" ? (
              <div className={["PageContent", styles.Transactions].join(" ")}>
                {brokers.map((item) => {
                  return <Transactions userId={user.id} broker={item.broker} />;
                })}
              </div>
            ) : null}

            {this.state.activeTab === "comments" ? (
              <div className={["PageContent", styles.Comments].join(" ")}>
                <Comments userId={user.id} />
              </div>
            ) : null}
          </>
        ) : null}
        <Spinner isLoading={this.state.isLoading} />
        <ToastContainer />
      </div>
    );
  }
}

export default View;
